import moment from "moment";

import { IDateTimeRange } from "./types";

export const getUtcDateTimeString = () => {
  return moment().utc().format("YYYY-MM-DDThh:mm:ss");
};

export const getLocalDateTimeString = () => {
  return moment().format("YYYY-MM-DDThh:mm:ss");
};

export const parseTimestampIntoLocalDateTime = (
  timestamp: number,
  format = "YYYY-MM-DD hh:mm:ss"
) => {
  return moment(timestamp).format(format);
};

export const parseTimestamp = (datetimeString: string) => {
  return moment(datetimeString).unix() * 1000;
};

export const getMonthBoundaryInUtc = (yearMonth: string): IDateTimeRange => {
  const DATE_PATTERN = "YYYY-MM";
  const currentMoment = moment(yearMonth, DATE_PATTERN, true);
  return {
    from: currentMoment.clone().startOf("month").utc().format(),
    to: currentMoment.clone().endOf("month").utc().format(),
  };
};

export const getYearBoundaryInUtc = (year: string): IDateTimeRange => {
  const DATE_PATTERN = "YYYY";
  const currentMoment = moment(year, DATE_PATTERN, true);
  return {
    from: currentMoment.clone().startOf("year").utc().format(),
    to: currentMoment.clone().endOf("year").utc().format(),
  };
};
